function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ComposeTemplate = require('./compose.template');
var MAX_IMAGES = 4;
var DEFAULT_CHAR_LIMIT = 500;
var POSTING_ANIMATION_MS = 500;
var MOBILE_KEYBOARD_MIN_HEIGHT = 100;
var ComposeOverlay = /*#__PURE__*/function () {
  function ComposeOverlay(app, mod) {
    var reply_to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    _classCallCheck(this, ComposeOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, true, true, false);
    this.overlay_id = 'redsquare-compose-overlay';
    this.placeholder = 'What is happening?';
    this.helper_text = 'Create a text post or drag-and-drop images…';
    this.avatar = '/saito/img/dreamscape.png';
    this.display_name = 'You';
    this.char_limit = DEFAULT_CHAR_LIMIT;
    this.default_reply_to = reply_to;
    this.reply_to = reply_to;
    this.mode = 'post';
    this.edit_tweet = null;
    this.images = [];
    this.posting = false;
    this.drag_drop_bound = false;
    this.gif_picker_rendered = false;
    this.visualViewport = null;
    this.visualViewportResizeHandler = null;
    this.onComplete = null;
  }
  return _createClass(ComposeOverlay, [{
    key: "open",
    value: function open() {
      var _this = this,
        _this$getRoot,
        _this$getRoot2;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.complete(null);
      this.images = [];
      this.posting = false;
      this.drag_drop_bound = false;
      this.gif_picker_rendered = false;
      this.edit_tweet = null;
      if (options.mode === 'retweet' || options.retweet_of) {
        this.mode = 'retweet';
        this.reply_to = options.retweet_of || options.reply_to || this.default_reply_to;
      } else if (options.mode === 'edit') {
        this.mode = 'edit';
        this.edit_tweet = options.tweet || null;
        this.reply_to = this.default_reply_to;
      } else if (options.reply_to || options.parentTweet) {
        this.mode = 'reply';
        this.reply_to = options.reply_to || options.parentTweet;
      } else {
        this.mode = 'post';
        this.reply_to = this.default_reply_to;
      }
      var profile = this.mod.profile || {};
      this.avatar = profile.avatar || '/saito/img/dreamscape.png';
      this.display_name = profile.name || 'You';
      if (this.mode === 'retweet') {
        this.placeholder = 'Add a comment…';
        this.helper_text = 'Add optional commentary or leave empty to retweet…';
      } else if (this.mode === 'edit') {
        this.placeholder = 'Edit your post…';
        this.helper_text = 'Tweets are editable for a brief period after posting…';
      } else if (this.mode === 'reply') {
        this.placeholder = 'Post your reply…';
        this.helper_text = 'Add your reply or drag-and-drop images…';
      } else {
        this.placeholder = 'What is happening?';
        this.helper_text = 'Create a text post or drag-and-drop images…';
      }
      if (options.prompt) {
        this.placeholder = String(options.prompt);
      }
      this.onComplete = typeof options.onComplete === 'function' ? options.onComplete : null;
      this.overlay.show(ComposeTemplate(this), function () {
        _this.removeVisualViewportResizeHandler();
        _this.complete(null);
      });
      var overlayHost = (_this$getRoot = this.getRoot()) === null || _this$getRoot === void 0 ? void 0 : _this$getRoot.closest('.saito-overlay');
      overlayHost === null || overlayHost === void 0 || overlayHost.classList.add('redsquare-compose-overlay-host');
      this.attachVisualViewportResizeHandler(overlayHost);
      this.attachEvents();
      var input = (_this$getRoot2 = this.getRoot()) === null || _this$getRoot2 === void 0 ? void 0 : _this$getRoot2.querySelector('.input');
      if (input && options.text != null) {
        input.value = String(options.text);
        this.updateCharacterCount();
      }
      setTimeout(function () {
        var _this$getRoot3;
        var input = (_this$getRoot3 = _this.getRoot()) === null || _this$getRoot3 === void 0 ? void 0 : _this$getRoot3.querySelector('.input');
        if (input) {
          input.focus();
        }
      }, 50);
    }
  }, {
    key: "close",
    value: function close() {
      var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.complete(result);
      this.removeVisualViewportResizeHandler();
      this.overlay.close();
      this.images = [];
      this.reply_to = this.default_reply_to;
      this.edit_tweet = null;
      this.mode = 'post';
      this.posting = false;
    }
  }, {
    key: "complete",
    value: function complete(result) {
      var callback = this.onComplete;
      this.onComplete = null;
      callback === null || callback === void 0 || callback(result);
    }
  }, {
    key: "getRoot",
    value: function getRoot() {
      return document.querySelector('.saito-overlay .compose');
    }
  }, {
    key: "attachVisualViewportResizeHandler",
    value: function attachVisualViewportResizeHandler(overlayHost) {
      var _this2 = this;
      if (!overlayHost || !window.visualViewport || window.innerWidth > 768) {
        return;
      }
      this.removeVisualViewportResizeHandler();
      this.visualViewport = window.visualViewport;
      this.visualViewportResizeHandler = function () {
        var _overlayHost$querySel;
        overlayHost.style.setProperty('--redsquare-compose-viewport-top', "".concat(_this2.visualViewport.offsetTop, "px"));
        overlayHost.style.setProperty('--redsquare-compose-viewport-height', "".concat(_this2.visualViewport.height, "px"));
        var coveredHeight = window.innerHeight - _this2.visualViewport.height - _this2.visualViewport.offsetTop;
        (_overlayHost$querySel = overlayHost.querySelector('.compose')) === null || _overlayHost$querySel === void 0 || _overlayHost$querySel.classList.toggle('keyboard-visible', coveredHeight > MOBILE_KEYBOARD_MIN_HEIGHT);
        overlayHost.scrollTop = 0;
      };
      this.visualViewportResizeHandler();
      this.visualViewport.addEventListener('resize', this.visualViewportResizeHandler);
      this.visualViewport.addEventListener('scroll', this.visualViewportResizeHandler);
    }
  }, {
    key: "removeVisualViewportResizeHandler",
    value: function removeVisualViewportResizeHandler() {
      if (this.visualViewport && this.visualViewportResizeHandler) {
        this.visualViewport.removeEventListener('resize', this.visualViewportResizeHandler);
        this.visualViewport.removeEventListener('scroll', this.visualViewportResizeHandler);
      }
      this.visualViewport = null;
      this.visualViewportResizeHandler = null;
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      var root = this.getRoot();
      if (!root) {
        return;
      }
      this.mountPickersForViewport();
      var input = root.querySelector('.input');
      var submitBtn = root.querySelector('.submit');
      var emojiBtn = root.querySelector('.tool.emoji');
      var imageBtn = root.querySelector('.tool.image');
      var gifBtn = root.querySelector('.tool.gif');
      var fileInput = root.querySelector('.file-input');
      var emojiPicker = root.querySelector('.compose-emoji-picker');
      if (input) {
        input.addEventListener('input', function () {
          _this3.updateCharacterCount();
        });
        input.addEventListener('keydown', function (e) {
          if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
            e.preventDefault();
            _this3.submit();
          }
        });
      }
      if (submitBtn) {
        submitBtn.addEventListener('click', function (e) {
          e.preventDefault();
          _this3.submit();
        });
      }
      if (emojiBtn) {
        emojiBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (!_this3.posting) {
            _this3.showPicker('emoji');
          }
        });
      }
      if (emojiPicker) {
        emojiPicker.addEventListener('emoji-click', function (e) {
          var _e$detail;
          _this3.insertEmoji((_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.unicode);
        });
      }
      if (imageBtn && fileInput) {
        imageBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (!_this3.posting) {
            fileInput.click();
          }
        });
        fileInput.addEventListener('change', /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
            var _e$target$files;
            var file;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  file = (_e$target$files = e.target.files) === null || _e$target$files === void 0 ? void 0 : _e$target$files[0];
                  if (file) {
                    _context.n = 1;
                    break;
                  }
                  return _context.a(2);
                case 1:
                  _context.n = 2;
                  return _this3.ingestFile(file);
                case 2:
                  fileInput.value = '';
                case 3:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
      if (gifBtn) {
        gifBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (!_this3.posting) {
            _this3.openGifPicker();
          }
        });
      }
      root.querySelectorAll('.compose-picker-close').forEach(function (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          _this3.hidePickers();
        });
      });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.querySelector('.compose-picker.visible')) {
          e.preventDefault();
          e.stopPropagation();
          _this3.hidePickers();
        }
      });
      if (!this.drag_drop_bound) {
        this.app.browser.addDragAndDropFileUploadToElement(this.overlay_id, /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(file) {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  if (_this3.posting) {
                    _context2.n = 1;
                    break;
                  }
                  _context2.n = 1;
                  return _this3.ingestDataUrl(file);
                case 1:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }(), false);
        this.drag_drop_bound = true;
      }
      this.updateCharacterCount();
    }
  }, {
    key: "showPicker",
    value: function showPicker(type) {
      var _root$closest,
        _this4 = this;
      var root = this.getRoot();
      if (!root) {
        return;
      }
      this.mountPickersForViewport();
      root.querySelectorAll('.compose-picker').forEach(function (picker) {
        var visible = picker.classList.contains("".concat(type, "-picker-panel"));
        picker.classList.toggle('visible', visible);
        picker.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
      root.classList.add('picker-open');
      (_root$closest = root.closest('.saito-overlay')) === null || _root$closest === void 0 || _root$closest.classList.add('picker-open');
      if (type === 'emoji' && typeof customElements !== 'undefined') {
        customElements.whenDefined('emoji-picker').then(function () {
          var _this4$getRoot;
          var search = (_this4$getRoot = _this4.getRoot()) === null || _this4$getRoot === void 0 || (_this4$getRoot = _this4$getRoot.querySelector('.compose-emoji-picker')) === null || _this4$getRoot === void 0 || (_this4$getRoot = _this4$getRoot.shadowRoot) === null || _this4$getRoot === void 0 ? void 0 : _this4$getRoot.querySelector('input.search');
          if (search && !_this4.app.browser.isMobileBrowser()) {
            search.focus({
              focusVisible: true
            });
          }
        });
      }
    }
  }, {
    key: "mountPickersForViewport",
    value: function mountPickersForViewport() {
      var root = this.getRoot();
      var surface = root === null || root === void 0 ? void 0 : root.querySelector('.surface');
      if (!root || !surface || typeof window === 'undefined') {
        return;
      }

      // Desktop pickers anchor below the dialog; mobile pickers stay over the input surface.
      var isDesktop = window.matchMedia ? window.matchMedia('(min-width: 769px)').matches : window.innerWidth > 768;
      var target = isDesktop ? root : surface;
      root.querySelectorAll('.compose-picker').forEach(function (picker) {
        if (picker.parentElement !== target) {
          target.appendChild(picker);
        }
      });
    }
  }, {
    key: "hidePickers",
    value: function hidePickers() {
      var _root$closest2, _root$querySelector;
      var root = this.getRoot();
      if (!root) {
        return;
      }
      root.querySelectorAll('.compose-picker').forEach(function (picker) {
        picker.classList.remove('visible');
        picker.setAttribute('aria-hidden', 'true');
      });
      root.classList.remove('picker-open');
      (_root$closest2 = root.closest('.saito-overlay')) === null || _root$closest2 === void 0 || _root$closest2.classList.remove('picker-open');
      (_root$querySelector = root.querySelector('.input')) === null || _root$querySelector === void 0 || _root$querySelector.focus();
    }
  }, {
    key: "insertEmoji",
    value: function insertEmoji(unicode) {
      var _this$getRoot4, _input$selectionStart, _input$selectionEnd;
      var input = (_this$getRoot4 = this.getRoot()) === null || _this$getRoot4 === void 0 ? void 0 : _this$getRoot4.querySelector('.input');
      if (!input || !unicode || this.posting) {
        return;
      }
      var start = (_input$selectionStart = input.selectionStart) !== null && _input$selectionStart !== void 0 ? _input$selectionStart : input.value.length;
      var end = (_input$selectionEnd = input.selectionEnd) !== null && _input$selectionEnd !== void 0 ? _input$selectionEnd : start;
      input.setRangeText(unicode, start, end, 'end');
      input.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
  }, {
    key: "openGifPicker",
    value: function openGifPicker() {
      var _this$app$modules$ret,
        _this$app$modules,
        _this5 = this;
      if (this.images.length >= MAX_IMAGES) {
        salert('Maximum 4 images allowed per tweet.');
        return;
      }
      var root = this.getRoot();
      var container = root === null || root === void 0 ? void 0 : root.querySelector('.gif-picker-content');
      if (!root || !container) {
        return;
      }
      this.showPicker('gif');
      if (this.gif_picker_rendered) {
        return;
      }
      var gifProvider = (_this$app$modules$ret = (_this$app$modules = this.app.modules).returnFirstRespondTo) === null || _this$app$modules$ret === void 0 ? void 0 : _this$app$modules$ret.call(_this$app$modules, 'giphy');
      if (!(gifProvider !== null && gifProvider !== void 0 && gifProvider.renderInto)) {
        this.hidePickers();
        siteMessage('GIF search is unavailable.', 1500);
        return;
      }
      this.gif_picker_rendered = true;
      gifProvider.renderInto("#".concat(this.overlay_id, " .gif-picker-content"), function (gifSource) {
        if (_this5.posting || !gifSource) {
          return;
        }
        if (_this5.images.length >= MAX_IMAGES) {
          salert('Maximum 4 images allowed per tweet.');
        } else {
          _this5.addImagePreview(gifSource);
        }
        _this5.hidePickers();
      });
    }
  }, {
    key: "setPostingState",
    value: function setPostingState(active) {
      var root = this.getRoot();
      if (!root) {
        return;
      }
      root.classList.toggle('posting', active);
      var screen = root.querySelector('.posting-screen');
      if (screen) {
        screen.setAttribute('aria-hidden', active ? 'false' : 'true');
      }
      root.querySelectorAll('button, textarea, input').forEach(function (el) {
        if (el.classList.contains('file-input')) {
          return;
        }
        el.disabled = active;
      });
    }
  }, {
    key: "getText",
    value: function getText() {
      var _this$getRoot5;
      var input = (_this$getRoot5 = this.getRoot()) === null || _this$getRoot5 === void 0 ? void 0 : _this$getRoot5.querySelector('.input');
      return input ? input.value : '';
    }
  }, {
    key: "updateCharacterCount",
    value: function updateCharacterCount() {
      var root = this.getRoot();
      if (!root) {
        return;
      }
      var current = root.querySelector('.char-count .current');
      var countWrap = root.querySelector('.char-count');
      var length = this.getText().length;
      if (current) {
        current.textContent = String(length);
      }
      if (countWrap) {
        countWrap.classList.toggle('warning', length > this.char_limit);
      }
    }
  }, {
    key: "ingestFile",
    value: function () {
      var _ingestFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(file) {
        var _this6 = this;
        var reader;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (file) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              reader = new FileReader();
              reader.onload = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      _context3.n = 1;
                      return _this6.ingestDataUrl(reader.result);
                    case 1:
                      return _context3.a(2);
                  }
                }, _callee3);
              }));
              reader.readAsDataURL(file);
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      function ingestFile(_x3) {
        return _ingestFile.apply(this, arguments);
      }
      return ingestFile;
    }()
  }, {
    key: "ingestDataUrl",
    value: function () {
      var _ingestDataUrl = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dataUrl) {
        var type, allowed, resized;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!(!dataUrl || typeof dataUrl !== 'string')) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              if (!(this.images.length >= MAX_IMAGES)) {
                _context5.n = 2;
                break;
              }
              salert('Maximum 4 images allowed per tweet.');
              return _context5.a(2);
            case 2:
              if (!dataUrl.includes('giphy.gif')) {
                _context5.n = 3;
                break;
              }
              this.addImagePreview(dataUrl);
              return _context5.a(2);
            case 3:
              type = dataUrl.substring(dataUrl.indexOf(':') + 1, dataUrl.indexOf(';'));
              allowed = this.mod.allowed_upload_types || [];
              if (!(allowed.length > 0 && !allowed.includes(type))) {
                _context5.n = 4;
                break;
              }
              salert("Cannot upload ".concat(type, " image! Allowed file types: ").concat(allowed.join(', ')));
              return _context5.a(2);
            case 4:
              _context5.n = 5;
              return this.app.browser.resizeImg(dataUrl);
            case 5:
              resized = _context5.v;
              this.addImagePreview(resized);
            case 6:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function ingestDataUrl(_x4) {
        return _ingestDataUrl.apply(this, arguments);
      }
      return ingestDataUrl;
    }()
  }, {
    key: "addImagePreview",
    value: function addImagePreview(src) {
      var _this$getRoot6,
        _this7 = this;
      var container = (_this$getRoot6 = this.getRoot()) === null || _this$getRoot6 === void 0 ? void 0 : _this$getRoot6.querySelector('.image-preview');
      if (!container || !src) {
        return;
      }
      var index = this.images.length;
      var html = "\n      <figure class=\"image-item\" data-index=\"".concat(index, "\">\n        <img src=\"").concat(src, "\" alt=\"\" />\n        <div class=\"image-remove\" role=\"button\" tabindex=\"0\" title=\"Remove image\" aria-label=\"Remove image\">\n          <i class=\"fa-solid fa-xmark\"></i>\n        </div>\n      </figure>\n    ");
      this.app.browser.addElementToSelector(html, ".saito-overlay #redsquare-compose-surface .image-preview");
      this.images.push(src);
      var item = container.querySelector(".image-item[data-index=\"".concat(index, "\"]"));
      var removeBtn = item === null || item === void 0 ? void 0 : item.querySelector('.image-remove');
      if (removeBtn) {
        var removeImage = function removeImage(e) {
          e.preventDefault();
          e.stopPropagation();
          _this7.removeImageAt(index);
        };
        removeBtn.addEventListener('click', removeImage);
        removeBtn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            removeImage(e);
          }
        });
      }
    }
  }, {
    key: "removeImageAt",
    value: function removeImageAt(index) {
      var _this$getRoot7;
      this.images.splice(index, 1);
      var container = (_this$getRoot7 = this.getRoot()) === null || _this$getRoot7 === void 0 ? void 0 : _this$getRoot7.querySelector('.image-preview');
      if (!container) {
        return;
      }
      container.innerHTML = '';
      var saved = this.images.slice();
      this.images = [];
      var _iterator = _createForOfIteratorHelper(saved),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var src = _step.value;
          this.addImagePreview(src);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "buildPostData",
    value: function buildPostData() {
      var text = this.getText();
      var data = {
        text: text
      };
      if (this.images.length > 0) {
        data.images = this.images.slice();
      }
      if (this.mode === 'reply' && this.reply_to) {
        data.parent_id = this.reply_to.signature || '';
        data.thread_id = this.reply_to.thread_id || this.reply_to.signature || '';
      }
      return data;
    }
  }, {
    key: "buildRetweetData",
    value: function buildRetweetData() {
      var _this$reply_to;
      var text = this.getText().trim();
      var data = {
        signature: ((_this$reply_to = this.reply_to) === null || _this$reply_to === void 0 ? void 0 : _this$reply_to.signature) || ''
      };
      if (text) {
        data.text = text;
      }
      if (this.images.length > 0) {
        data.images = this.images.slice();
      }
      return data;
    }
  }, {
    key: "collectRecipientKeys",
    value: function collectRecipientKeys() {
      var _source$tx;
      var keys = [];
      var source = this.mode === 'edit' ? this.edit_tweet : this.reply_to;
      if (source !== null && source !== void 0 && source.publicKey && !keys.includes(source.publicKey)) {
        keys.push(source.publicKey);
      }
      if (source !== null && source !== void 0 && (_source$tx = source.tx) !== null && _source$tx !== void 0 && _source$tx.to) {
        var _iterator2 = _createForOfIteratorHelper(source.tx.to),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var slip = _step2.value;
            var publicKey = slip === null || slip === void 0 ? void 0 : slip.publicKey;
            if (publicKey && !keys.includes(publicKey)) {
              keys.push(publicKey);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      return keys;
    }
  }, {
    key: "submit",
    value: function () {
      var _submit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _this$reply_to2,
          _this8 = this;
        var text, isRetweet, _this$app$wallet, wallet_balance, crypto, minimumAnimation, keys, _data, _yield$Promise$all, _yield$Promise$all2, _tx, _this$edit_tweet, _data2, _yield$Promise$all3, _yield$Promise$all4, _tx2, data, _yield$Promise$all5, _yield$Promise$all6, tx, tweet, _this$mod$manager, _t;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              if (!this.posting) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              text = this.getText().trim();
              isRetweet = this.mode === 'retweet';
              if (!(!isRetweet && this.images.length === 0 && text.length === 0)) {
                _context9.n = 2;
                break;
              }
              siteMessage('Post Empty', 1000);
              return _context9.a(2);
            case 2:
              if (!(isRetweet && !((_this$reply_to2 = this.reply_to) !== null && _this$reply_to2 !== void 0 && _this$reply_to2.signature))) {
                _context9.n = 3;
                break;
              }
              siteMessage('Unable to retweet', 2500);
              return _context9.a(2);
            case 3:
              if (!(text.length > this.char_limit)) {
                _context9.n = 6;
                break;
              }
              wallet_balance = 0;
              crypto = (_this$app$wallet = this.app.wallet) === null || _this$app$wallet === void 0 ? void 0 : _this$app$wallet.saitoCrypto;
              if (!(crypto && typeof crypto.getPendingBalance === 'function')) {
                _context9.n = 5;
                break;
              }
              _context9.n = 4;
              return crypto.getPendingBalance();
            case 4:
              wallet_balance = _context9.v;
            case 5:
              if (!(Number(wallet_balance) == 0)) {
                _context9.n = 6;
                break;
              }
              siteMessage('Accounts with SAITO can write longer posts...', 3000);
              return _context9.a(2);
            case 6:
              this.posting = true;
              this.setPostingState(true);
              minimumAnimation = new Promise(function (resolve) {
                setTimeout(resolve, POSTING_ANIMATION_MS);
              });
              _context9.p = 7;
              keys = this.collectRecipientKeys();
              if (!isRetweet) {
                _context9.n = 10;
                break;
              }
              _data = this.buildRetweetData();
              _context9.n = 8;
              return Promise.all([minimumAnimation, _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
                var unsigned;
                return _regenerator().w(function (_context6) {
                  while (1) switch (_context6.n) {
                    case 0:
                      _context6.n = 1;
                      return _this8.mod.createRetweetTransaction(_data, keys);
                    case 1:
                      unsigned = _context6.v;
                      _context6.n = 2;
                      return unsigned.sign();
                    case 2:
                      _context6.n = 3;
                      return _this8.app.network.propagateTransaction(unsigned);
                    case 3:
                      return _context6.a(2, unsigned);
                  }
                }, _callee6);
              }))()]);
            case 8:
              _yield$Promise$all = _context9.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              _tx = _yield$Promise$all2[1];
              _context9.n = 9;
              return this.mod.receiveRetweetTransaction(_tx);
            case 9:
              if (!this.mod.browser_active) {
                siteMessage('Retweet sent', 1000);
              }
              this.close(_tx);
              return _context9.a(2, _tx);
            case 10:
              if (!(this.mode === 'edit')) {
                _context9.n = 14;
                break;
              }
              if ((_this$edit_tweet = this.edit_tweet) !== null && _this$edit_tweet !== void 0 && _this$edit_tweet.signature) {
                _context9.n = 11;
                break;
              }
              siteMessage('Unable to edit tweet', 2500);
              this.setPostingState(false);
              this.posting = false;
              return _context9.a(2);
            case 11:
              _data2 = {
                text: text,
                tweet_id: this.edit_tweet.signature
              };
              _context9.n = 12;
              return Promise.all([minimumAnimation, _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
                var unsigned;
                return _regenerator().w(function (_context7) {
                  while (1) switch (_context7.n) {
                    case 0:
                      _context7.n = 1;
                      return _this8.mod.createEditTweetTransaction(_data2, keys);
                    case 1:
                      unsigned = _context7.v;
                      _context7.n = 2;
                      return unsigned.sign();
                    case 2:
                      _context7.n = 3;
                      return _this8.app.network.propagateTransaction(unsigned);
                    case 3:
                      return _context7.a(2, unsigned);
                  }
                }, _callee7);
              }))()]);
            case 12:
              _yield$Promise$all3 = _context9.v;
              _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
              _tx2 = _yield$Promise$all4[1];
              _context9.n = 13;
              return this.mod.receiveEditTweetTransaction(_tx2);
            case 13:
              siteMessage('Edit Request Broadcast: it may take a minute for your request to propagate...', 4000);
              this.close(_tx2);
              return _context9.a(2, _tx2);
            case 14:
              data = this.buildPostData();
              _context9.n = 15;
              return Promise.all([minimumAnimation, _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
                var unsigned;
                return _regenerator().w(function (_context8) {
                  while (1) switch (_context8.n) {
                    case 0:
                      _context8.n = 1;
                      return _this8.mod.createTweetTransaction(data, keys);
                    case 1:
                      unsigned = _context8.v;
                      _context8.n = 2;
                      return unsigned.sign();
                    case 2:
                      _context8.n = 3;
                      return _this8.app.network.propagateTransaction(unsigned);
                    case 3:
                      return _context8.a(2, unsigned);
                  }
                }, _callee8);
              }))()]);
            case 15:
              _yield$Promise$all5 = _context9.v;
              _yield$Promise$all6 = _slicedToArray(_yield$Promise$all5, 2);
              tx = _yield$Promise$all6[1];
              _context9.n = 16;
              return this.mod.receiveTweetTransaction(tx);
            case 16:
              tweet = _context9.v;
              if (tweet) {
                (_this$mod$manager = this.mod.manager) === null || _this$mod$manager === void 0 || _this$mod$manager.onTweetPosted(tweet);
              }
              if (!this.mod.browser_active) {
                siteMessage('Tweet sent', 1000);
              }
              this.close(tx);
              return _context9.a(2, tx);
            case 17:
              _context9.p = 17;
              _t = _context9.v;
              console.error('RedSquare compose submit failed:', _t);
              siteMessage(isRetweet ? 'Unable to retweet' : this.mode === 'edit' ? 'Unable to edit tweet' : 'Unable to post tweet', 2500);
              this.setPostingState(false);
              this.posting = false;
            case 18:
              return _context9.a(2);
          }
        }, _callee9, this, [[7, 17]]);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }()
  }]);
}();
module.exports = ComposeOverlay;